import React from 'react'
import PropTypes from 'prop-types'
import { LogTimelineRow, ProfilePicture } from '../../../../components/generic'

const HandoverResidentItem = ({ data }) => {
  const { logs, resident } = data
  if (!logs || !logs.length || !resident) return null
  const chosenName = resident.preferredName || resident.name.first
  return (
    <div>
      <div style={styles.residentContainer}>
        <ProfilePicture type="handover" url={resident.picture} />
        <span style={styles.residentName}>
          <span style={styles?.preferredName}>{chosenName}</span> (
          {`${resident.name.first} ${resident.name.last}`})
        </span>
      </div>
      <ul style={styles.logContainer}>
        {logs.map((log, i) => {
          return (
            <LogTimelineRow
              dateFormat={'ddd HH:mm'}
              key={log.id}
              log={log}
              index={i}
              total={logs.length}
            />
          )
        })}
      </ul>
    </div>
  )
}

const styles = {
  logContainer: {
    listStyleType: 'none',
    paddingLeft: 0,
    paddingBottom: 0,
    paddingRight: 100,
    position: 'relative',
    top: 20,
    left: 70,
  },
  residentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  residentName: {
    fontSize: 16,
    position: 'relative',
    top: 12,
    left: 20,
  },
  preferredName: {
    fontWeight: 'bold',
  },
}
HandoverResidentItem.propTypes = {
  data: PropTypes.object.isRequired,
}

export default HandoverResidentItem
